module.exports = __webpack_public_path__ + "static/media/loreal4.faaf8201.jpg";